module.exports = __webpack_public_path__ + "static/media/waic-activity-finish.3b3ae8d5.png";